import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHelmComponent } from './simple-icons-helm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHelmComponent ],
    exports:      [ SimpleIconsHelmComponent ],
    bootstrap:    []
})
export class SimpleIconsHelmModule {}
